module.exports = __webpack_public_path__ + "static/2-34040090b3deb3221fa9c2f9eb30f696.jpg";